module.exports = __webpack_public_path__ + "642f780c14f69d0ea56bee7f12252df9.png";